@let deliverableForm = form();

@if (deliverableForm) {
  @switch (type()) {
    @case (EDeliverableType.title) {
      <app-title
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.gamePlay) {
      <app-game-play
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [executionValues]="[]"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.chatBot) {
      <app-chatbot
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.chatbotMulti) {
      <app-chatbot-multi
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.talkingPoint) {
      <app-talking-point
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.talkingPointAi) {
      <app-talking-point-ai
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.visual) {
      <app-visual
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.productPlacement) {
      <app-product-placement
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.showcase) {
      <app-showcase
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.custom) {
      <app-custom
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.content) {
      <app-content
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.textTracking) {
      <app-text-tracking
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.audioTracking) {
      <app-audio-tracking
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.caption) {
      <app-caption
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.hashTag) {
      <app-hashtag
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.mention) {
      <app-mention
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.message) {
      <app-message
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
    @case (EDeliverableType.description) {
      <app-description
        [form]="deliverableForm"
        [platformFeature]="platformFeature()"
        [creatorId]="null"
        [isCustomMode]="false"
        [creators]="[]"
        [isParentDeleteDisabled]="true"
        [isExpanded]="true"
      />
    }
  }
}
